import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

/**
 * Distintivo permanente del entorno de pruebas.
 *
 * Producción y pruebas se ven idénticos, así que sin una marca visible es cuestión de
 * tiempo que alguien confunda una pestaña con la otra y dé por buena una prueba hecha
 * sobre datos reales (o al revés). Se muestra solo cuando `envName` es `staging`; en
 * desarrollo y en producción el componente no renderiza nada.
 *
 * Es un elemento fijo con `pointer-events-none` para no tapar ni bloquear la interfaz.
 */
@Component({
  selector: 'app-env-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (isStaging) {
      <div
        class="pointer-events-none fixed bottom-3 left-3 z-[9999] select-none rounded-full border border-amber-500/40 bg-amber-400/95 px-3 py-1 text-xs font-bold uppercase tracking-wider text-amber-950 shadow-lg"
        role="status"
        aria-label="Entorno de pruebas"
      >
        Pruebas
      </div>
    }
  `,
})
export class EnvBanner {
  protected readonly isStaging = environment.envName === 'staging';
}
